import { render, staticRenderFns } from "./remitAmazon.vue?vue&type=template&id=855094c2&scoped=true"
import script from "./remitAmazon.vue?vue&type=script&lang=js"
export * from "./remitAmazon.vue?vue&type=script&lang=js"
import style0 from "./remitAmazon.vue?vue&type=style&index=0&id=855094c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855094c2",
  null
  
)

export default component.exports